import { render, staticRenderFns } from "./orderSend.vue?vue&type=template&id=58fc766a&scoped=true"
import script from "./orderSend.vue?vue&type=script&lang=js"
export * from "./orderSend.vue?vue&type=script&lang=js"
import style0 from "./orderSend.vue?vue&type=style&index=0&id=58fc766a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fc766a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\java\\project\\fenxijunya-java\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58fc766a')) {
      api.createRecord('58fc766a', component.options)
    } else {
      api.reload('58fc766a', component.options)
    }
    module.hot.accept("./orderSend.vue?vue&type=template&id=58fc766a&scoped=true", function () {
      api.rerender('58fc766a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/orderSend.vue"
export default component.exports